import API from 'services/api';
import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options';

export const filters = ({
  securityCompanyId,
  userAssignedDepartments = [],
}) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'BusinessClient',
        field: 'businessClient',
        useAsyncInFilters: true,
        type: 'async-select',
        fetchOptions: API.fetchBusinessClientList,
        dataTransform: ({ data }) => {
          return data;
        },
        fetchFilters: {
          securityCompanyId,
          archived: false,
        },
        multiple: false,
        optionLabelKey: 'name',
      },
    ],
    AdvancedFilters: [...departmentFilterField],
  };
};
